/* import __COLOCATED_TEMPLATE__ from './search-tag.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();